<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="1060px"
    custom-class="batch-upload-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="download-wrapper">
      <el-form label-width="130px">
        <el-form-item label="歌曲信息" required>
          <verify-uploader
            action="/action/upload?type=excel"
            :on-preview="handlePreview"
            :on-remove="handleFileRemove"
            :on-error="handleFileError"
            :on-success="handleFileSuccess"
            :before-upload="handleFileBeforeUpload"
            :file-list="fileList"
            :accept="'.' + fileExtType.join(',.')"
          >
            <el-button size="mini" icon="el-icon-upload">上传文件</el-button>
            <a class="download-template-link" @click.stop="downloadTemplate">歌曲上传模板下载</a>
            <div slot="tip" class="el-upload__tip">支持格式：{{ fileExtType.join(',') }}</div>
          </verify-uploader>
        </el-form-item>
        <el-form-item v-if="!noRight" required>
          <template #label>
            <span>权利文件信息</span>
            <el-tooltip placement="top">
              <i class="el-icon-info" />
              <template #content>
                具体文件要求，请查看：<a href="https://doc.weixin.qq.com/doc/w3_AMAAvgZ6ACooVs4k4OATpC9MB3lbi?scode=AJEAIQdfAAouI78nuGAGQA6AbQACk" target="_blank">权利文件上传要求</a>
              </template>
            </el-tooltip>
          </template>
          <verify-uploader
            class="custom-uploader"
            action="/action/upload?type=license"
            drag
            multiple
            :on-preview="handlePreview"
            :on-remove="handleRightFileRemove"
            :on-error="handleRightFileError"
            :on-success="handleRightFileSuccess"
            :before-upload="handleRightFileBeforeUpload"
            :file-list="rightFileList"
            :accept="'.' + rightFileExtType.join(',.')"
          >
            <div slot="trigger" class="upload-trigger">
              <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
              <p>点击或将文件拖拽上传权利文件</p>
              <span>支持格式：{{ rightFileExtType.join(',') }}</span>
            </div>
          </verify-uploader>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" style="text-align: center;">
      <el-button @click="handleClose">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { validateFileExt } from '@/utils/validate'
import { downloadFile } from '@/utils/fileUtil'
import { VerifyUploader } from '@/components'

import {
  LEVEL_ONE_APPEAL,
  rightFileExtType,
  fileExtType
} from './const'

const templateFileMap = {
  [LEVEL_ONE_APPEAL.TORT.code]: '/file/complaint_songlist_template.xlsx',
  [LEVEL_ONE_APPEAL.OFFLINE.code]: '/file/offline_songlist_template.xlsx',
  [LEVEL_ONE_APPEAL.CP_NOTICE.code]: '/file/notice_songlist_template.xlsx',
}

export default {
  name: 'BatchUploadDialog',
  components: {
    VerifyUploader
  },
  props: {
    visible: Boolean,
    dialogTitle: {
      type: String,
      default: '批量上传'
    },
    bussType: {
      type: Number,
      default: LEVEL_ONE_APPEAL.TORT.code
    },
    noRight: Boolean
  },
  data() {
    return {
      fileExtType,
      rightFileExtType,
      templateFileMap,

      fileList: [],
      rightFileList: []
    }
  },

  methods: {
    downloadTemplate() {
      downloadFile(this.templateFileMap[this.bussType], '批量上传歌曲模板.xlsx')
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList
    },
    handleFileError(err, file, fileList) {
      this.fileList = fileList
      this.$message.error('文件上传失败: ' + err.message)
    },
    handleFileSuccess(resp, file, fileList) {
      this.handleSuccess(resp, file)
      this.fileList = fileList.slice(-1)
    },
    handleFileBeforeUpload(file) {
      return this.handleBeforeUpload(fileExtType, file, this.fileList)
    },

    handleRightFileRemove(file, fileList) {
      this.rightFileList = fileList
    },
    handleRightFileError(err, file, fileList) {
      this.rightFileList = fileList
      this.$message.error('授权文件上传失败: ' + err.message)
    },
    handleRightFileSuccess(resp, file, fileList) {
      this.handleSuccess(resp, file)
      this.rightFileList = fileList
    },
    handleRightFileBeforeUpload(file) {
      return this.handleBeforeUpload(rightFileExtType, file, this.rightFileList)
    },

    handlePreview(file) {
      open(file.url, '_blank')
    },
    handleSuccess(resp, file) {
      file.fileUrl = file.url = resp.data.url
      file.filePath = file.path = resp.data.file_id
      file.fileName = file.name
      file.md5 = resp.data.md5
    },
    handleBeforeUpload(extType, file, fileList) {
      if (!validateFileExt(extType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      const sameFile = fileList.find(v => v.md5 === file.md5)
      if (sameFile) {
        this.$message.warning(`文件已存在，请检查【${file.name}】和【${sameFile.name}】`)
        return Promise.reject()
      }

      return Promise.resolve()
    },

    handleClose() {
      this.fileList = []
      this.rightFileList = []
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    handleSubmit() {
      if (!this.fileList.length) {
        return this.$message.warning('请上传文件！')
      }
      if (!this.noRight && !this.rightFileList.length) {
        return this.$message.warning('请上传权利文件！')
      }

      this.$emit('submit', cloneDeep(this.fileList), cloneDeep(this.rightFileList))
      this.handleClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.download-wrapper {
  padding: 16px;
  background: #F9F9F9;
}
::v-deep .batch-upload-dialog {
  .el-upload-list {
    text-align: left;
  }

  .upload-trigger {
    margin-top: 16px;

    .upload-icon {
      width: 42px;
      height: 50px;
    }

    p {
      margin: 10px 0;
    }
  }

  .download-template-link {
    font-size: 12px;
    vertical-align: bottom;
    margin-left: 30px;
    text-decoration: underline;
  }

  .custom-uploader {
    .el-upload.el-upload--text {
      width: 50%;
      background: #F3F3F3;
      border: 1px dashed #4071FF;
      border-radius: 4px;
      padding: 10px;
    }

    .el-upload-dragger {
      background-color: unset;
      border: none;
      width: 100%;
      min-height: 180px;
      height: 100%;
    }
  }
}
</style>
